var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStays(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 116,
    viewBox: "0 0 142 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 142,
    height: 31,
    rx: 15.5,
    fill: "#38A872",
    style: (_ref2 = {
      fill: "#38A872"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.2196 0.6588 0.4471)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("rect", {
    y: 42.5,
    width: 142,
    height: 31,
    rx: 15.5,
    fill: "#3CA0C1",
    style: (_ref3 = {
      fill: "#3CA0C1"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.2353 0.6275 0.7569)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("rect", {
    y: 84.5,
    width: 92,
    height: 31,
    rx: 15.5,
    fill: "#F3B42C",
    style: (_ref4 = {
      fill: "#F3B42C"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.9529 0.7059 0.1725)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 84.5,
    width: 41,
    height: 31,
    rx: 15.5,
    fill: "#CB2560",
    style: (_ref5 = {
      fill: "#CB2560"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.7961 0.1451 0.3765)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStays);
export default __webpack_public_path__ + "static/media/icon-stays.7a8094e5babe62292e7dc4ae2dcfa832.svg";
export { ForwardRef as ReactComponent };